import { Button, Col, Row } from "react-bootstrap";

import "./providerCardStyles.css";

const ProviderCard = ({ name, logo, onClick }) => {
  return (
    <Button
      size="lg"
      variant="light"
      className="provider-card"
      onClick={onClick}
    >
      <Row>
        <Col xs={12}>
          <img className="provider-card-img" src={logo} alt={name} />
        </Col>
      </Row>
      <Row>
        <Col>
          <span className="provider-card-name">{name}</span>
        </Col>
      </Row>
    </Button>
  );
};

export default ProviderCard;
